module.exports = __webpack_public_path__ + "img/fig1.6f5f70a4.png";